<template>
  <div>
    <v-card>
        <v-card-title primary-title>
            پلن ها
        </v-card-title>
    </v-card>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss"></style>
